module.exports = __webpack_public_path__ + "img/get-in-touch.0f13515e.svg";